import React from 'react';
import styled from 'styled-components';
import { WalletAuth } from '../components/wallet/WalletAuth';

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #0d1117;
`;

const LoginBox = styled.div`
  padding: 2.5rem;
  background-color: #161b22;
  border: 1px solid #30363d;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
`;

const Title = styled.h1`
  font-size: 1.75rem;
  font-weight: 600;
  color: #f0f6fc;
  margin: 0 0 0.5rem 0;
`;

const Subtitle = styled.p`
  font-size: 1rem;
  color: #8b949e;
  margin: 0 0 2rem 0;
`;

export const LoginPage: React.FC = () => {
  const handleAuthSuccess = () => {
    // On successful authentication, the main App component will detect
    // the state change and handle the redirect to the dashboard.
    // This component's only job is to facilitate the login.
    console.log('Authentication successful. App will now redirect.');
  };

  return (
    <LoginContainer>
      <LoginBox>
        <Title>CondorV3 Access</Title>
        <Subtitle>Connect your wallet to access the application.</Subtitle>
        <WalletAuth onAuthSuccess={handleAuthSuccess} />
      </LoginBox>
    </LoginContainer>
  );
}; 